import snakeCase from 'lodash/snakeCase';

const snakeize = obj => {
  if (Array.isArray(obj)) {
    return obj.map(v => snakeize(v));
  } else if (obj !== null && obj !== undefined && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [snakeCase(key)]: snakeize(obj[key])
      }),
      {}
    );
  }

  return obj;
};

export default snakeize;
